<dx-popup [dragEnabled]="false" [height]="'auto'" [fullScreen]="appService.isSmallScreen()" [showTitle]="true"
  [hideOnOutsideClick]="false" [visible]="popupVisible && !reviewPopupVisible" (visibleChange)="onPopupVisibleChange($event)" [width]="660" contentTemplate="popupContent" maxHeight="90vh"
  title="{{titleKey | translate}}">
  <dxi-toolbar-item location="after" toolbar="bottom">
    <dx-button (onClick)="confirm()" [disabled]="!isFormValid()" [stylingMode]="'contained'" [type]="'default'"
      icon="save" text="{{'BUTTONS.CONFIRM' | translate}}"></dx-button>
  </dxi-toolbar-item>
  <dxi-toolbar-item location="after" toolbar="bottom">
    <dx-button (onClick)="cancel()" [stylingMode]="'outlined'" icon="close"
      text="{{'BUTTONS.CANCEL' | translate}}"></dx-button>
  </dxi-toolbar-item>

  <div *dxTemplate="let data of 'popupContent'">
    <div style="height: auto; overflow: hidden; display: flex; flex-direction: column; gap: 10px;">
      <dx-text-box [(value)]="newEntityName" [label]="nameKey | translate"
        [maxLength]="MAX_NAME_LENGTH" [valueChangeEvent]="'keyup'">
      </dx-text-box>

      <dx-tag-box *ngIf="dashboardService.canShareToOtherUsers()" [(value)]="selectedUserIds"
        [dataSource]="dashboardService.visibleUsers"
        [displayExpr]="dashboardService.visibleUserDisplayExpr" [label]="'DUPLICATE_ENTITY.RECIPIENTS' | translate" [multiline]="true"
        [searchEnabled]="true" [showDropDownButton]="true" [showSelectionControls]="true" valueExpr="id">
      </dx-tag-box>
    </div>

  </div>

</dx-popup>

<dx-popup [dragEnabled]="false" [height]="'auto'" [fullScreen]="appService.isSmallScreen()" [showTitle]="true"
  [hideOnOutsideClick]="false" [(visible)]="reviewPopupVisible" [width]="560" contentTemplate="reviewContent"
  maxHeight="90vh" title="{{reviewTitleKey | translate}}">
  <dxi-toolbar-item location="after" toolbar="bottom">
    <dx-button (onClick)="confirmReview()" [stylingMode]="'contained'" [type]="'default'" icon="save"
      text="{{'DUPLICATE_ENTITY.SHARE_ANYWAY' | translate}}"></dx-button>
  </dxi-toolbar-item>
  <dxi-toolbar-item location="after" toolbar="bottom">
    <dx-button (onClick)="cancelReview()" [stylingMode]="'outlined'" icon="close"
      text="{{'BUTTONS.CANCEL' | translate}}"></dx-button>
  </dxi-toolbar-item>

  <div *dxTemplate="let data of 'reviewContent'">
    <div *ngIf="skippedTargets.length > 0" class="skipped-targets">
      <span>{{'DUPLICATE_ENTITY.SKIPPED_MESSAGE' | translate}}</span>
      <ul>
        <li *ngFor="let target of skippedTargets">{{ skippedTargetLabel(target) }}</li>
      </ul>
    </div>
    <div *ngIf="partialTargets.length > 0" class="partial-targets">
      <span>{{'DUPLICATE_ENTITY.PARTIAL_MESSAGE' | translate}}</span>
      <ul>
        <li *ngFor="let target of partialTargets">{{ targetName(target) }}</li>
      </ul>
    </div>
  </div>

</dx-popup>
